<template>
  <div>
    <b-navbar variant="light">
      <b-navbar-brand href="#">
        <strong @click="enableDebug($event)">Daily Schedule</strong>
      </b-navbar-brand>
      <b-collapse id="nav-collapse" is-nav>
        <b-navbar-nav>
          <form class="form-inline">
            <o-date-time
              :disabled="hasUnsavedChanges"
              :form-state="form_state"
              hide-time
              name="start_date"
              @input="setDate"
              nolabel
              :value="start_date"
            ></o-date-time>

            <b-button :disabled="hasUnsavedChanges" @click="load_all"
              >Load</b-button
            >

            <b-button
              :disabled="!hasUnsavedChanges"
              @click="save"
              variant="success"
              >Save {{ number_of_changes }}
              changes
            </b-button>

            <b-button
              :disabled="!hasUnsavedChanges"
              @click="discardChanges"
              class="ml-5"
              variant="warning"
              >Discard All Changes
            </b-button>
          </form>
        </b-navbar-nav>
      </b-collapse>
    </b-navbar>

    <o-working-overlay :working="job_working"></o-working-overlay>

    <FullCalendar ref="fullCalendar" :options="calendarOptions" />
    <b-row id="itemdraggable">
      <b-card
        v-for="(list, index) in pumpList"
        :style="'background-color: ' + list.color"
        :key="index"
        height="15px"
        :background="list.color"
        width="50p"
        :data-event="JSON.stringify(list)"
        class="mb-2 item-class"
      >
        <b-card-title>
          {{ list.description }}
          <small>({{ list.count || 0 }})</small>
        </b-card-title>
      </b-card>
    </b-row>
    <!-- {{ pump_items }} -->
  </div>
</template>

<style></style>

<script>
import "@fullcalendar/core/vdom"; // solves problem with Vite
import FullCalendar from "@fullcalendar/vue";
import interactionPlugin, { Draggable } from "@fullcalendar/interaction";
import resourceTimelinePlugin from "@fullcalendar/resource-timeline";

import _ from "lodash";

import { CreateCodeTableFetchMixin } from "../../../vue-ocom/mixins";
import schema from "../../schema/index";
import { mapActions, mapGetters } from "vuex";
import moment from "moment";
import { ACTION_TYPES } from "../../../vue-ocom/store/store_keys";

export default {
  components: { FullCalendar },
  mixins: [CreateCodeTableFetchMixin(["Customer", "CodeJobType", "CodeArea"])],
  data: function () {
    var today = moment().toISOString().split("T")[0];

    return {
      debug: false,
      start_date: today,
      schema: schema.Job,

      form_state: { dirty: false, debug: false } /* For ODateTime */,

      added: [],
      updated: [],
      removed: [],

      filter_list: [
        { name: "All", code: "all", options: { offset: 0, sort: "id" } },
      ],
      event_list: {},
      deleted_event_list: {},

      count_colours: {
        null: "#f2f2f3",
        0: "#f2f2f3",
        1: "#90EE90",
        2: "#1E90FF",
        3: "#FAFAD2",
        4: "#F08080",
      },
    };
  },
  methods: {
    ...mapActions("JobModule", { job_getAll: ACTION_TYPES.GET_ALL }),
    ...mapActions("PumpModule", { pump_getAll: ACTION_TYPES.GET_ALL }),
    ...mapActions("JobAssignmentModule", {
      jobAssignment_getAll: ACTION_TYPES.GET_ALL,
      jobAssignment_save: ACTION_TYPES.SAVE_ITEM,
      jobAssignment_delete: ACTION_TYPES.DELETE_ITEM,
    }),
    load_all() {
      var pump_options = {
        limit: 10000,
        offset: 0,
        sort: "description",
        order: "asc",
        filter: "active",
      };
      this.pump_getAll(pump_options);
      this.fetch_job();
      this.fetch_job_assignment();
      this.form_state.dirty = false;
    },
    fetch_job_assignment() {
      let start_date = moment(this.start_date);
      let end_date = moment(this.start_date).add(1, "days");
      var jobAssignment_options = {
        when_date: start_date._d.toISOString(),
        end_date: end_date._d.toISOString(),
        limit: 10000,
        offset: 0,
        sort: "id",
        order: "asc",
      };
      this.jobAssignment_getAll(jobAssignment_options);
    },
    fetch_job() {
      var options = {
        query: { and: [["job_date", "eq", this.start_date]] },
        filter: "for_allocation",
        sort: "area_id",
        limit: 10000,
      };
      this.job_getAll(options);
    },
    enableDebug($event) {
      this.debug = !this.debug;
    },

    handleDateClick(arg) {
      alert("date click! " + arg.dateStr);
    },

    setDate(date) {
      this.start_date = date;
      this.fetch_job();
      this.fetch_job_assignment();
      let calendarApi = this.$refs.fullCalendar.getApi();
      calendarApi.gotoDate(date);
    },
    save() {
      var vm = this;

      var promises_promises = []; // all promises!

      function saveItem(item) {
        promises_promises.push(
          vm.jobAssignment_save(item).then(function (newItem) {
            _.forEach(newItem, function (value, key) {
              vm.$set(item, key, value);
            });
          })
        );
      }
      function deleteItem(item) {
        promises_promises.push(
          vm.jobAssignment_delete(item).then(function (newItem) {
            _.forEach(newItem, function (value, key) {
              vm.$set(item, key, value);
            });
          })
        );
      }
      _.forEach(vm.event_list, saveItem);

      _.forEach(vm.deleted_event_list, deleteItem);

      Promise.all(promises_promises).then(function () {
        vm.discardChanges();
      });
    },
    discardChanges() {
      this.added = [];
      this.updated = [];
      this.removed = [];
      this.event_list = {};
      this.deleted_event_list = {};
      this.load_all(); // get data again so we are sure it's recent
      let Fcalendar = this.$refs.fullCalendar.getApi();
      Fcalendar.getEvents().forEach((event) => {
        event.remove();
      });
    },

    addItem(item) {
      this.added.push(item);
    },
    updateItem(item) {
      this.updated.push(item);
    },
    edit(item) {
      this.$router.push({ name: "job.edit", params: { id: item.id } });
    },
    setter(obj) {
      let vm = this;
      if (obj.event.extendedProps["pk"] == undefined) {
        vm.addItem({
          pump: parseInt(obj.event.id),
          defId: obj.event._instance.defId,
          active_start_date: obj.event.start,
          active_end_date: obj.event.end,
          _new: true,
        });
      } else {
        vm.updateItem({
          pump: parseInt(obj.event.id),
          id: obj.event.extendedProps["pk"],
          defId: obj.event.extendedProps["pk"],
          active_start_date: obj.event.start,
          active_end_date: obj.event.end,
          _new: false,
        });
      }
    },
    eventRender(info) {
      const vm = this;
      var btn = document.createElement("button");
      btn.id = info.event._instance.defId;
      btn.appendChild(document.createTextNode("x"));
      btn.addEventListener("click", () => {
        vm.setter(info);
        info.event.remove();
        var key;
        if (info.event.extendedProps["pk"] == undefined) {
          key = info.event._instance.defId;
        } else {
          key = info.event.extendedProps["pk"];
          let item = {
            defId: info.event._instance.defId,
            pump: parseInt(info.event.id),
            id: info.event.extendedProps["pk"],
            pk: info.event.extendedProps["pk"],
            active_start_date: info.event.start,
            active_end_date: info.event.end,
            job: parseInt(info.event._def.resourceIds[0]),
          };
          vm.$set(vm.deleted_event_list, key, item);
        }
        vm.$delete(vm.event_list, key);
      });
      info.el.appendChild(btn);
    },
    eventReceive(info) {
      this.setter(info);
      let vm = this;
      let key = 0;
      if (info.event.extendedProps != {}) {
        key = info.event._instance.defId;
      } else {
        key = info.event.extendedProps["pk"];
      }
      let item = {
        defId: info.event._instance.defId,
        pump: parseInt(info.event.id),
        active_start_date: info.event.start,
        active_end_date: info.event.end,
        job: parseInt(info.event._def.resourceIds[0]),
        _new: true,
      };
      vm.$set(vm.event_list, key, item);
    },
    updateHandleEvents(updateEvents) {
      this.setter(updateEvents);
      let vm = this;
      let key = 0;
      if (updateEvents.event.extendedProps["pk"] == undefined) {
        key = updateEvents.event._instance.defId;
      } else {
        key = updateEvents.event.extendedProps["pk"];
      }

      let item = {
        defId: updateEvents.event._instance.defId,
        pump: parseInt(updateEvents.event.id),
        id: updateEvents.event.extendedProps["pk"],
        active_start_date: updateEvents.event.start,
        active_end_date: updateEvents.event.end,
        job: parseInt(updateEvents.event._def.resourceIds[0]),
        _new: false,
      };
      vm.$set(vm.event_list, key, item);
    },
    draggable() {
      let draggableEl = document.getElementById("itemdraggable");
      new Draggable(draggableEl, {
        itemSelector: ".item-class",
        eventData: function (eventEl) {
          var ob = JSON.parse(eventEl.dataset.event);
          return {
            id: ob.id,
            color: "#3788d8",
            duration: "04:00",
            forceEventDuration: true,
            textColor: "black",
            title: eventEl.innerText,
          };
        },
      });
    },
  },

  computed: {
    ...mapGetters("JobModule", {
      job_items: "items",
      job_total: "total_items",
      job_working: "working",
      job_items_by_id: "itemsByID",
    }),
    ...mapGetters("PumpModule", {
      pump_items: "items",
      pump_total: "total_items",
      pump_working: "working",
      pump_byID: "itemsByID",
    }),
    ...mapGetters("JobAssignmentModule", {
      jobAssignment_items: "items",
      jobAssignment_total: "total_items",
      jobAssignment_working: "working",
      jobAssignment_byID: "itemsByID",
    }),

    working() {
      return this.job_working || this.pump_working;
    },
    calendarOptions() {
      const vm = this;

      // Calculate the Resources to show
      var resources = [];
      _.map(this.job_items, function (item) {
        var address =
          item.suburb != "" ? `${item.address}, ${item.suburb}` : item.address;
        resources.push({
          id: item.id,
          title: address.toUpperCase(),
          area: item.area_description,
        });
      });

      // Calculate the Events to show
      let cal_event_list = [];
      this.jobAssignment_items.forEach(function (item) {
        var end = new Date(item.active_start_date);
        if (item.active_end_date) {
          end = item.active_end_date;
        } else {
          end.setHours(end.getHours() + 4);
        }
        cal_event_list.push({
          pk: item.id,
          id: item.pump,
          color: "#3788d8",
          textColor: "black",
          resourceId: item.job,
          start: item.active_start_date,
          end: end,
          title: vm.pump_byID[item.pump].description,
        });
      });
      return {
        plugins: [resourceTimelinePlugin, interactionPlugin],
        themeSystem: "bootstrap",
        refetchResourcesOnNavigate: true,
        resourceOrder: "-area",
        resourceGroupField: "area",
        headerToolbar: false,
        editable: true,
        nowIndicator: true, // show Current Time on there
        eventDidMount: this.eventRender,
        // eventRemove: this.eventRemove,
        eventStartEditable: true,
        eventResizableFromStart: true,
        eventDurationEditable: true,
        eventResourceEditable: true,
        selectable: true,
        droppable: true, // this allows things to be dropped onto the calendar
        aspectRatio: 1,
        eventReceive: this.eventReceive,
        eventChange: this.updateHandleEvents,
        dayMaxEvents: true,
        height: 600,
        slotMinTime: "05:00:00",
        slotMaxTime: "18:00:00",
        initialDate: vm.start_date,
        now: vm.start_date,
        initialView: "resourceTimeline",
        schedulerLicenseKey: "CC-Attribution-NonCommercial-NoDerivatives",
        resourceAreaColumns: [
          {
            headerContent: "Address",
            field: "title",
          },
          {
            headerContent: "Area",
            field: "area",
            group: true,
            width: "25%",
          },
        ],
        resources: resources,
        events: cal_event_list,
      };
    },

    number_of_changes() {
      return (
        (this.added || []).length +
        (this.updated || []).length +
        (this.removed || []).length
      );
    },
    hasUnsavedChanges() {
      if (this.added && this.added.length > 0) {
        return true;
      }
      if (this.updated && this.updated.length > 0) {
        return true;
      }
      if (this.removed && this.removed.length > 0) {
        return true;
      }

      return false; // not changes to save so we are good.
    },
    pumpList() {
      const vm = this;
      // Add the color and count to the pump_items
      return _.map(this.pump_items, function (pi) {
        return {
          ...pi,
          color: vm.count_colours[Math.min(vm.pump_count[pi.id] || 0, 4)],
          count: vm.pump_count[pi.id],
        };
      });
    },
    pump_count() {
      const vm = this;
      var result = _.countBy(this.jobAssignment_items, "pump");

      _.forEach(vm.event_list, function (evt) {
        result[evt.pump] = (result[evt.pump] || 0) + 1;
      });

      _.forEach(vm.deleted_event_list, function (evt) {
        result[evt.pump] = (result[evt.pump] || 0) - 1;
      });

      return result;
    },
  },
  created() {
    this.load_all();
  },
  mounted() {
    this.draggable();
  },
};
</script>

<style>
div.task_type_1 {
  background-color: #cbefe8 !important;
  color: black;
}
</style>
